import { USER_ROLE } from "src/services/AuthService"

export const getBuyerBalancesByTeam = (users: IUserSaved[]) => {
	const balances = new Map<string, number>()

	for (const user of users) {
		if (user.company_role !== USER_ROLE.BUYER || !user.team_uid) continue
		balances.set(user.team_uid, (balances.get(user.team_uid) || 0) + Number(user.team_balance || 0))
	}

	return balances
}

export const getTotalBuyerBalance = (balancesByTeam: Map<string, number>) =>
	Array.from(balancesByTeam.values()).reduce((total, balance) => total + balance, 0)

export const getAverageBuyerBalancePerTeam = (totalBuyerBalance: number, teamsCount: number) =>
	teamsCount > 0 ? totalBuyerBalance / teamsCount : 0

export const getDashboardBuyerBalance = (
	companyBuyersBalance: number,
	users: IUserSaved[],
	role?: string,
	visibleTeamUids: Iterable<string> = []
) => {
	if (role !== USER_ROLE.TEAM_LEAD) return companyBuyersBalance

	const visibleTeams = new Set(visibleTeamUids)
	const visibleBalances = Array.from(getBuyerBalancesByTeam(users).entries()).filter(
		([teamUid]) => visibleTeams.has(teamUid)
	)
	return getTotalBuyerBalance(new Map(visibleBalances))
}
